'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = template;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _index = require('../style/index');

var _index2 = _interopRequireDefault(_index);

var _reactTransitionGroup = require('react-transition-group');

var _lodash = require('lodash.omit');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function template() {
    var _this = this;

    var classList = this.compileStyle(_index2.default),
        animationItems = null,
        attrs = void 0,
        iconWrapper = void 0,
        rippleFx = '',
        icon = null;

    if (this.props.children) {
        icon = _react2.default.createElement(
            'div',
            { className: classList.icon },
            this.props.children
        );
    } else if (typeof this.props.icon === 'string') {
        icon = _react2.default.createElement('img', {
            src: this.props.icon,
            alt: this.props.title,
            width: this.props.width,
            height: this.props.height,
            disabled: this.props.disabled,
            className: classList.icon
        });
    } else {
        icon = _react2.default.createElement(
            'div',
            {
                className: classList.icon,
                style: {
                    width: this.props.width,
                    height: this.props.height
                }
            },
            this.props.icon
        );
    }

    if (!this.props.disabled && this.props.ripple && this.state.animation.length) {
        animationItems = [];

        this.state.animation.forEach(function (item) {
            animationItems.push(_react2.default.createElement(
                _reactTransitionGroup.CSSTransition,
                {
                    classNames: classList.animation,
                    timeout: { enter: 450 },
                    exit: false,
                    key: item.key
                },
                _react2.default.createElement('div', { className: classList.animation, style: { background: _this.props.rippleColor } })
            ));
        });
    }

    // all attributes, exclude components one, goes to button attributes
    attrs = (0, _lodash2.default)(this.props, ['icon', 'rippleColor', 'ripple', 'iconFx', 'title', 'width', 'height', 'disabled', 'theme']);

    if (this.props.disabled) {
        iconWrapper = classList.iconWrapperDisabled;
    } else {
        rippleFx = this.props.ripple ? classList.rippleFx : '';
        iconWrapper = this.props.iconFx ? classList.iconWrapperFx : classList.iconWrapper;
    }

    return _react2.default.createElement(
        'div',
        _extends({}, attrs, {
            className: classList.root + ' ' + (this.props.className || '')
        }),
        _react2.default.createElement(
            'div',
            {
                className: iconWrapper + ' ' + rippleFx,
                onClick: this._handleClick,
                style: {
                    width: this.props.width,
                    height: this.props.height
                }
            },
            _react2.default.createElement(
                _reactTransitionGroup.TransitionGroup,
                { component: null },
                animationItems
            ),
            icon
        )
    );
}